/* eslint-disable camelcase */
import PeerReviewExperiments from 'bundles/epic/clients/PeerReview';

export type ReduceLowValueFeedbackType = {
  isControl: boolean;
  isA: boolean;
  isB: boolean;
  isC: boolean;
  minCount?: number;
};

export const getReduceLowValueFeedback = (courseId: string): ReduceLowValueFeedbackType => {
  const control = PeerReviewExperiments.get('reduceLowValueFeedbackControl', { course_id: courseId });
  const variantA = PeerReviewExperiments.get('reduceLowValueFeedbackA', { course_id: courseId });
  const variantB = PeerReviewExperiments.get('reduceLowValueFeedbackB', { course_id: courseId });
  const variantC = PeerReviewExperiments.get('reduceLowValueFeedbackC', { course_id: courseId });

  let minCount: number | undefined;
  if (variantA?.enabled) {
    minCount = variantA?.minCount;
  } else if (variantC?.enabled) {
    minCount = variantC?.minCount;
  }

  return {
    isControl: control?.enabled,
    isA: variantA?.enabled,
    isB: variantB?.enabled,
    isC: variantC?.enabled,
    minCount,
  };
};

export const isPeerReviewFileAIGradingEnabledImpression = (): boolean => {
  const isRollout = PeerReviewExperiments.get('aiGradingEnabledForFileUploads') === true;
  const isPaidConsumer = PeerReviewExperiments.get('aiGradingEnabledForFileUploadsForPaidConsumer') === true;
  const isEnterprise = PeerReviewExperiments.get('aiGradingEnabledForFileUploadsForEnterprise') === true;
  return isRollout || isPaidConsumer || isEnterprise;
};

export const isPeerReviewFileAIGradingEnabledPreview = (): boolean => {
  return (
    PeerReviewExperiments.preview('aiGradingEnabledForFileUploads') === true ||
    PeerReviewExperiments.preview('aiGradingEnabledForFileUploadsForEnterprise') === true ||
    PeerReviewExperiments.preview('aiGradingEnabledForFileUploadsForPaidConsumer') === true
  );
};

// Epic: https://tools.coursera.org/epic/experiment/GJjSGR7KEe-HYhKGMOMXtw
export const isPeerReviewAIGradingRolloutPaidEnabledPreview = (): boolean => {
  return (
    PeerReviewExperiments.preview('aiGradingEnabledForEnterpriseAndPaidConsumer') === true ||
    PeerReviewExperiments.preview('aiGradingEnabledForE2E') === true
  );
};

// Epic: https://tools.coursera.org/epic/experiment/GJjSGR7KEe-HYhKGMOMXtw
export const isPeerReviewAIGradingRolloutPaidEnabledImpression = (): boolean => {
  return (
    PeerReviewExperiments.get('aiGradingEnabledForEnterpriseAndPaidConsumer') === true ||
    PeerReviewExperiments.preview('aiGradingEnabledForE2E') === true
  );
};

// Epic: https://tools.coursera.org/epic/experiment/8Sdk1ydnEe-HYhKGMOMXtw
export const isPeerReviewAIGradingRolloutAllEnabledPreview = (): boolean => {
  return PeerReviewExperiments.preview('aiGradingRolloutEnabledForAll') === true;
};

// Epic: https://tools.coursera.org/epic/experiment/8Sdk1ydnEe-HYhKGMOMXtw
export const isPeerReviewAIGradingRolloutAllEnabledImpression = (): boolean => {
  return PeerReviewExperiments.get('aiGradingRolloutEnabledForAll') === true;
};

export const isFullyAiGradingEnabled = (): boolean => {
  return PeerReviewExperiments.preview('fullyAiGraded') === true;
};

// Epic: https://tools.coursera.org/epic/experiment/-RjztDKAEfCp_w6fFr_gMQ
export const isSelfServedAiGrading = (): boolean => {
  return PeerReviewExperiments.preview('selfServedAiGrading') === true;
};
